import { useEffect } from "react";

const useOnMount = (callback) => {
  // eslint-disable-next-line
  useEffect(callback, []);
};

export default useOnMount;
